<script lang="ts" setup>
import { IPLogo } from "@/components/icons"
import AuthLayoutBanner from "@/assets/images/AuthLayoutBanner.png"
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import LanguageSelect from "@/components/LanguageSelect.vue"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const breakpoints = useBreakpoints(breakpointsTailwind)
</script>
<template>
	<div class="auth-layout">
		<div v-if="breakpoints.greater('lg').value" class="auth-layout_banner" :style="{ backgroundImage: 'url(' + AuthLayoutBanner + ')' }">
			<div class="banner-logo">
				<IPLogo />
			</div>
			<div class="banner-caption">{{ t("layouts.welcome_future") }}</div>
			<div class="banner-footer">{{ t("layouts.copyright") }}</div>
		</div>
		<div class="auth-layout_content">
			<div class="auth-layout_lang">
				<LanguageSelect />
			</div>
			<router-view />
		</div>
	</div>
</template>

<style lang="scss">
.auth-layout {
	@include flex(0, row, start, center);

	width: 100%;
	min-height: 100vh;

	&_banner {
		@include flex(1.6rem, column, center, center);

		height: 100vh;
		width: 100%;
		flex: 1;
		padding: 42px 24px;
		position: relative;
		background-color: #000212;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}

	&_content {
		@include flex(0, row, center, center);
		position: relative;

		height: 100%;
		width: 100%;
		flex: 1;
		// Horizontal padding so the card doesn't touch the screen edges on
		// mobile (it used to be 0, leaving the card flush to both sides).
		padding: 1.6rem;
	}

	&_lang {
		// Pinned to the top-right corner of the viewport, independent of the
		// card width or language.
		position: fixed;
		top: 2.4rem;
		right: 2.4rem;
		inset-inline-end: 2.4rem;
		z-index: 50;
	}
}

.banner {
	&-logo {
		color: var(--bg-primary);
	}

	&-caption {
		@include font(2.2rem, 300, 4rem);

		background: linear-gradient(135deg, var(--gs-400) 30%, var(--gs-200) 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		text-fill-color: transparent;
		text-align: center;
	}

	&-footer {
		@include font(1.4rem, 500, 1.7rem);

		position: absolute;
		bottom: 4.2rem;
		letter-spacing: -0.02em;
		text-align: center;
		color: var(--gs-300);
	}
}
</style>
